import React, { useEffect } from "react";
import { useRequestFinished } from "../../../common/hooks";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import Form from "../../../common/form";
import { listRequest } from "../../../../store/slices/rolesSlice";
import { bulkCreateRequest } from "../../../../store/slices/usersSlice";
import AddUserForm from "./AddUserForm";
import { defaultUserType, isSsoSetUp } from "../../../../helpers/SsoHelper";

export const AddUser = ({
  action,
  bulkCreateRequest,
  enterprise,
  error,
  labels,
  listRequest,
  parent,
  requesting,
  roles,
}) => {
  useEffect(() => {
    listRequest();
  }, [listRequest]);

  const defaultRole = roles.find((role) => role.name === "Learner");

  const navigate = useNavigate();
  const intl = useIntl();

  // The user type is chosen only once the organisation has company sign-in;
  // otherwise the API keeps its default (Local).
  const ssoSetUp = isSsoSetUp(enterprise);

  const bulkCreateUsers = (data) => {
    const payload = data.users.map((user) => ({
      ...user,
      email: user.email || "",
      roleId: user.roleId.id || defaultRole.id,
      ...(ssoSetUp ? { profileType: Number(user.profileType) } : {}),
    }));
    bulkCreateRequest({
      learners: payload,
    });
  };

  // Only a save answered while this screen is open: the persisted store can
  // still say "update" from an earlier save when the screen mounts (F-BUG-12).
  const requestFinished = useRequestFinished(requesting);
  useEffect(() => {
    if (
      requestFinished &&
      !error &&
      (action === "bulk-create" || action === "update" || action === "delete")
    ) {
      navigate(parent.to);
    }
  }, [requestFinished, error, action, navigate, parent.to]);

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "add_user" })}
          </div>
        </div>
        <div className="edexlms-page-body">
          <Form
            submitBtn={{
              label: intl.formatMessage({ id: "add_users" }),
              onClick: bulkCreateUsers,
            }}
            cancelBtn={{
              label: intl.formatMessage({ id: "cancel" }),
              onClick: () => navigate(parent.to),
            }}
            initialValues={{
              users: [
                {
                  firstName: "",
                  lastName: "",
                  roleId: defaultRole,
                  email: "",
                  ...(ssoSetUp ? { profileType: defaultUserType(enterprise) } : {}),
                },
              ],
            }}
            requesting={requesting}
          >
            <AddUserForm defaultRole={defaultRole} />
          </Form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  roles: state.roles?.data?.list || [],
  enterprise: state?.global?.enterprise,
  action: state?.users?.action,
  error: state?.users?.error,
  requesting: state?.users?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  listRequest: () => dispatch(listRequest()),
  bulkCreateRequest: (data) => dispatch(bulkCreateRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
